import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    jobJobScoreforms: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_JOBSCOREFORM_SELECT_IDS (store, ids) {
      store.jobJobScoreforms.selectIds = ids
    },
    REMOVE_JOBSCOREFORM_SELECT_IDS (store, ids) {
      store.jobJobScoreforms.selectIds = store.jobJobScoreforms.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_JOBSCOREFORM_SELECT_ID (store, id) {
      store.jobJobScoreforms.selectId = id
    },
    SET_JOBSCOREFORM_FILTERS (store, filters) {
      store.jobJobScoreforms.filters = filters
    },
    SET_JOBSCOREFORM_PAGINATE (store, val) {
      store.jobJobScoreforms.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getJobScoreforms: (store, getters) => {
      return store.jobJobScoreforms.selectIds.map((id) => {
        return getters['entities/scoreforms/find'](id)
      })
    },
    getJobScoreformsFilters: (store, getters) => {
      return store.jobJobScoreforms.filters
    },
    getJobScoreformsPaginate: (store, getters) => {
      return store.jobJobScoreforms.paginate
    },
    getJobScoreform: (store, getters) => {
      return getters['entities/scoreforms/find'](store.jobJobScoreforms.selectId) || {}
    }
  },
  actions: {
    /*
    selectJobScoreforms
    */
    selectJobScoreforms ({commit, dispatch, getters, state}, filters) {
      return dispatch('getJobScoreforms', filters)
      .then((response) => {
        commit('SET_JOBSCOREFORM_FILTERS', filters)
        commit('SET_JOBSCOREFORM_PAGINATE', response)
        commit('SET_JOBSCOREFORM_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectJobScoreforms
    */
    refreshSelectJobScoreforms ({commit, dispatch, getters, state}) {
      return dispatch('selectJobScoreforms', getters.getJobScoreformsFilters)
    },
    /*
    selectJobScoreform
    */
    selectJobScoreform ({commit, dispatch, getters, state}, id) {
      return dispatch('getJobScoreformById', id)
      .then((response) => {
        commit('SET_JOBSCOREFORM_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getJobScoreforms
    */
    getJobScoreforms ({commit, dispatch, getters, state}, { job_id: jobId, ...filters }) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/jobs/${jobId}/scoreforms`, {params: filters})
      .then((response) => {
        return dispatch('entities/scoreforms/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.scoreforms || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getAvailableJobScoreforms
    */
    getAvailableJobScoreforms ({commit, dispatch, getters, state}, { job_id: jobId, ...filters }) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/jobs/${jobId}/scoreforms/available`, { params: filters })
      .then((response) => {
        return dispatch('entities/scoreforms/insert', {
          data: response.data
        })
        .then((result) => {
          return result.scoreforms
        })
      })
    },
    /*
    getJobScoreformById
    */
    getJobScoreformById ({commit, dispatch, getters, state}, { job_id: jobId, id }) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/jobs/${jobId}/scoreforms/${id}`)
      .then((response) => {
        return dispatch('entities/scoreforms/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.scoreforms[0]
      })
    },
    /*
    createJobScoreform
    */
    createJobScoreform ({commit, dispatch, getters, state}, { job_id: jobId, ...data }) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/jobs/${jobId}/scoreforms`, data)
      .then((response) => {
        return dispatch('entities/scoreforms/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.scoreforms[0]
      })
    },
    /*
    updateJobScoreform
    */
    updateJobScoreform ({commit, dispatch, getters, state}, { job_id: jobId, _id: id, ...data }) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/jobs/${jobId}/scoreforms/${id}`, data)
      .then((response) => {
        return dispatch('entities/scoreforms/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.scoreforms[0]
      })
    },
    /*
    deleteJobScoreform
    */
    deleteJobScoreform ({commit, dispatch, getters, state}, { job_id: jobId, id }) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/jobs/${jobId}/scoreforms/${id}`)
      .then((response) => {
        commit('REMOVE_JOBSCOREFORM_SELECT_IDS', [id])
        dispatch('entities/scoreforms/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/JobScoreform.js